import React from "react";

interface FormRowVerticalProps {
  label: string;
  required?: boolean;
  /** Show "(optional)" in lighter grey for non-required fields */
  optional?: boolean;
  error?: string;
  children: React.ReactNode;
  className?: string;
  /** Tighter spacing between label and input */
  compact?: boolean;
  /** Renders on the same row as the label, right-aligned (e.g. a toggle) */
  labelRight?: React.ReactNode;
}

const FormRowVertical: React.FC<FormRowVerticalProps> = ({
  label,
  required,
  optional,
  error,
  children,
  className = "",
  compact = false,
  labelRight,
}) => {
  return (
    <div className={`w-full ${className}`}>
      <div className={`flex items-center justify-between gap-2 ${compact ? "mb-0.5" : "mb-1"}`}>
        <label className="text-[#9B9B9B] text-[11px] font-[300] shrink-0">
          {label}
          {required && <span className="text-red-500 ml-0.5">*</span>}
          {optional && !required && <span className="text-[#A3A3A3] font-normal ml-1">(optional)</span>}
        </label>
        {labelRight}
      </div>
      {children}
      {error && <div className="text-orange text-xs mt-1">{error}</div>}
    </div>
  );
};

export default FormRowVertical;
